import { apiClient, api } from '../../../../services/api'
import { invitationApi } from '../../../../services/userApi'
import { FranchisePartner } from '../hooks/useFranchisePartnersData'
import { Filters } from '../hooks/useFranchisePartnersFilters'

export interface InspectorTokenResponse {
  token: string
  url: string
  expires_at: string
}

export interface InvitationResponse {
  id: number
  fp_id: number
  fp_code: string
  token: string
  invitation_url: string
  is_used: boolean
  created_at: string
  expires_at: string
}

export const franchisePartnersService = {
  // Fetch all franchise partners
  fetchAll: async (enabledOnly: boolean = false) => {
    const response = await apiClient.get(`/franchise-partners?enabled_only=${enabledOnly}`)
    return response.data.partners || []
  },

  // Fetch single franchise partner
  fetchOne: async (fpCode: string): Promise<FranchisePartner> => {
    const response = await apiClient.get(`/franchise-partners/${fpCode}`)
    return response.data
  },

  // Update franchise partner status
  updateStatus: async (fpCode: string, newStatus: string) => {
    const response = await apiClient.patch(`/admin/franchise-partners/${fpCode}/status`, {
      fp_status: newStatus
    })
    return response.data
  },

  // Toggle ICU flag
  toggleICU: async (fpCode: string, isIcu: boolean) => {
    const response = await apiClient.patch(`/admin/franchise-partners/${fpCode}/icu`, {
      is_icu: isIcu
    })
    return response.data
  },

  // Toggle Selling flag
  toggleSelling: async (fpCode: string, isSelling: boolean) => {
    const response = await apiClient.patch(`/admin/franchise-partners/${fpCode}/selling`, {
      is_selling: isSelling
    })
    return response.data
  },

  // Update adoption status
  updateAdoption: async (fpCode: string, adoptionStatus: string | null, adoptionNote?: string) => {
    const response = await apiClient.patch(`/admin/franchise-partners/${fpCode}/adoption`, {
      adoption_status: adoptionStatus,
      adoption_note: adoptionNote
    })
    return response.data
  },

  // Export franchise partners to Excel
  export: async (filters: Partial<Filters>) => {
    const params = new URLSearchParams()
    if (filters.market) params.append('market', filters.market)
    if (filters.systemStatus) params.append('system_status', filters.systemStatus)
    if (filters.fpStatus) params.append('fp_status', filters.fpStatus)
    if (filters.textSearch) params.append('search', filters.textSearch)

    const response = await apiClient.get(`/admin/franchise-partners/export?${params.toString()}`, {
      responseType: 'blob'
    })
    return response.data
  },

  // Create new invitation (regenerate)
  createInvitation: async (fp: FranchisePartner): Promise<InvitationResponse> => {
    const response = await invitationApi.createInvitation({
      fp_id: fp.id,
      expires_in_days: 100
    })
    return response.data
  },

  // Get data counts for a franchise partner
  getDataCounts: async (fpCode: string) => {
    const response = await apiClient.get(`/admin/franchise-partners/${fpCode}/data-counts`)
    return response.data
  }
}